import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import GoogleTagManagerProvider from '../../providers/GoogleTagManager';

const blockEl = 'page';

const Page = ({ alert, className, header, navLink, children, state }) => (
  <GoogleTagManagerProvider gtmId="GTM-5PWF2V">
    <div className={classNames(blockEl, className, 'container-lg my-0 mx-auto')}>
      {alert && (
        <div className={`${blockEl}__alert`}>
          <div
            className={`alert alert-${alert.variant || 'success'} alert-dismissible fade show`}
            role="alert"
          >
            {alert.text}
          </div>
        </div>
      )}
      {navLink && (
        <div className={`${blockEl}__nav-link`}>
          <Link
            className={`${blockEl}__nav-link--${navLink.variant || 'back'}`}
            to={navLink.href}
            state={state}
          >
            {navLink.displayName}
          </Link>
        </div>
      )}
      <div className={`${blockEl}__header`}>
        <h1>{header.title}</h1>
        {header.content && <div className={`${blockEl}__header-content`}>{header.content}</div>}
      </div>
      <div className={`${blockEl}__content`}>{children}</div>
    </div>
  </GoogleTagManagerProvider>
);

Page.propTypes = {
  header: PropTypes.shape({
    title: PropTypes.string.isRequired,
    content: PropTypes.node
  }).isRequired,
  alert: PropTypes.shape({
    text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
    show: PropTypes.bool,
    variant: PropTypes.string
  }),
  className: PropTypes.string,
  navLink: PropTypes.shape({
    displayName: PropTypes.string.isRequired,
    href: PropTypes.string.isRequired,
    variant: PropTypes.oneOf(['back', 'forward'])
  }),
  children: PropTypes.node.isRequired,
  state: PropTypes.shape({})
};

Page.defaultProps = {
  alert: null,
  className: null,
  navLink: null,
  state: {}
};

export default Page;
